import * as Factory from "factory";
import * as faker from "faker";
import { nanoid } from "nanoid";
// https://spin.atomicobject.com/2017/03/15/typescript-generate-test-data/
export const webPaywallFactory = Factory.Sync.makeFactoryWithRequired({
    id: Factory.each((i)=>i),
    name: Factory.each(()=>faker.name.firstName()),
    url: "http://web-paywall-ui.superwall.localhost/paywalls/base1",
    identifier: nanoid(),
    primaryProductId: 1,
    substitutions: {
        substitutions: []
    },
    createdAt: new Date(),
    updatedAt: new Date()
});
export const webPaywallWithoutIds = ({ ...args } = {})=>{
    const { applicationId, id, primaryProductId, ...webPaywall } = webPaywallFactory.build({
        applicationId: 1,
        ...args
    });
    return webPaywall;
};
